var map = {
	"./android/DeviceSetup": 1264,
	"./androidtv/DeviceSetup": 1265,
	"./arris/DeviceSetup": 1266,
	"./hisense/DeviceSetup": 1267,
	"./lg/DeviceSetup": 1268,
	"./nagra/DeviceSetup": 1270,
	"./netrange/DeviceSetup": 1271,
	"./opera/DeviceSetup": 1272,
	"./polaroid/DeviceSetup": 1273,
	"./ps4/DeviceSetup": 1274,
	"./samsung/DeviceSetup": 1275,
	"./seirobotics/DeviceSetup": 1276,
	"./sony/DeviceSetup": 1277,
	"./stbcoship/DeviceSetup": 1278,
	"./stbcoship9108/DeviceSetup": 1279,
	"./stbhuawei/DeviceSetup": 1280,
	"./stbkaon/DeviceSetup": 1281,
	"./tizen/DeviceSetup": 1282,
	"./web0s/DeviceSetup": 1283,
	"./workstation/DeviceSetup": 1285,
	"./workstationChafari/DeviceSetup": 1286,
	"./zeasn/DeviceSetup": 1287,
	"./zte/DeviceSetup": 1288
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1263;


//////////////////
// WEBPACK FOOTER
// ./src/devices ^\.\/.*\/DeviceSetup$
// module id = 1263
// module chunks = 0